import { render, staticRenderFns } from "./addIUJP.vue?vue&type=template&id=2f7b6670&scoped=true&"
import script from "./addIUJP.vue?vue&type=script&lang=js&"
export * from "./addIUJP.vue?vue&type=script&lang=js&"
import style0 from "./addIUJP.vue?vue&type=style&index=0&id=2f7b6670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b6670",
  null
  
)

export default component.exports